import { vuexOidcCreateStoreModule } from 'vuex-oidc';
import { oidcSettings } from '@/config/oidc';

export default vuexOidcCreateStoreModule(oidcSettings, {
	name: 'oidcStore',
	namespaced: true,
	isAuthenticatedBy: 'access_token',
	dispatchEventsOnWindow: true
});
